import { useMutation, useQueryClient } from 'react-query'

// eslint-disable-next-line import/no-internal-modules
import { SystemPreferencesRepository } from '@webapp/platform/iam/data-access/repositories/SystemPreferencesRepository'
// eslint-disable-next-line import/no-internal-modules
import { systemPreferencesKeys } from '@webapp/platform/iam/data-access/repositories/SystemPreferencesRepository/queryKey.factory'
// eslint-disable-next-line import/no-internal-modules
import { SystemPreferenceKeys } from '@webapp/platform/iam/entities/enums/SystemPreferenceKeys'

export const useMutateDefaultPODisclaimer = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    // Set = the label id; clear = 0 — both via the same POST (BHV-023/024)
    mutationFn: (idOrZero: number) =>
      SystemPreferencesRepository.updateSystemPreference(
        SystemPreferenceKeys.DEFAULT_DISCLAIMER,
        idOrZero
      ),
    onSuccess: () => {
      // Refetches the mounted default read → the star updates
      queryClient.invalidateQueries(systemPreferencesKeys.all)
    },
  })

  return {
    mutateAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading,
  }
}
